import React from 'react';
import './CTACard.css';

const CTACard = ({ image, altText, title, description, link, linkText, reverse }) => {
  // Define the dimensions based on your CSS constraints or image dimensions
  const imageWidth = 600;  // Use the actual width of the image or a reasonable default
  const imageHeight = 400; // Use the actual height of the image or a reasonable default

  return (
    <div className={`cta-card ${reverse ? 'reverse' : ''}`}>
      <div className="cta-card-image-container">
        <img 
          src={image} 
          alt={altText} 
          className="cta-card-image" 
          width={imageWidth} 
          height={imageHeight} 
        />
      </div>
      <div className="cta-card-content">
        <h2 className="cta-card-title">{title}</h2>
        <p className="cta-card-description">{description}</p>
        {link && linkText && ( // Conditional rendering of the <a> tag
          <a href={link} className="cta-card-link" target="_blank" rel="noopener noreferrer">
            <strong>{linkText}</strong>
          </a>
        )}
      </div>
    </div>
  );
};

export default CTACard;
